import {
  Module,
  VuexModule,
  Mutation,
  getModule,
  Action
} from "vuex-module-decorators";
import { store } from "@/store";
import { Vue } from "vue-property-decorator";
import axios from "axios";
import { prepareRequest } from "@/utils/request";
import { config } from "@/utils/config/config.ts";
import { MessageModule } from "@/store/modules/messageModule";

interface CenterType {
  lat: number;
  lng: number;
}

interface MarksType {
  id: number;
  position: CenterType;
  type: string;
}

@Module({
  dynamic: true,
  store,
  name: "MapStore",
  namespaced: true
})
class MapStore extends VuexModule {
  active = false;
  requestError = false;
  request = false;
  stores = {};
  center: CenterType = { lat: 0, lng: 0 };
  marks: MarksType[] = [];
  images = false;
  activePopUp = false;
  mainSlide = "";
  activeZip = "";

  get isRequestError(): boolean {
    return this.requestError;
  }

  get isActiveStatus(): boolean {
    return this.active;
  }

  get isRequest(): boolean {
    return this.request;
  }

  get isSavedZip(): string {
    return this.activeZip
  }

  get isGalleryCollection(): boolean {
    return this.images;
  }

  @Mutation
  public SAVE_ZIPCODE(zip: string) {
    this.activeZip = zip
  }

  @Mutation
  public CREATE_MARKS(data: any): any {
    this.marks = []
    Object.keys(data).forEach((value, i) => {
      const tmp = {
        position: {
          lat: Number(data[i]["project"].lat),
          lng: Number(data[i]["project"].lng)
        },
        type: "default",
        id: data[i]["project"].id
      };
      if (i === 0) {
        //first pin position on map view
        this.center = {
          lat: Number(data[i]["project"].lat),
          lng: Number(data[i]["project"].lng)
        };
      }
      this.marks.push(tmp);
    });
  }
  @Mutation
  public EXTEND_STORE_DATA(data: any): any {
    Object.keys(data).forEach(i => {
      data[i]["project"]["active"] = false;
      //temporary for image collection
      // if (data[i]["project"]["mainImageCollection"].length == 0) {
      //   data[i]["project"]["mainImageCollection"] = [
      //     config.appImgUrl + "images/1.jpg",
      //     config.appImgUrl + "images/2.jpg",
      //     config.appImgUrl + "images/3.jpg",
      //     config.appImgUrl + "images/4.jpg",
      //     config.appImgUrl + "images/5.jpg",
      //     config.appImgUrl + "images/6.jpg",
      //     config.appImgUrl + "images/7.jpg",
      //     config.appImgUrl + "images/8.jpg"
      //   ];
      // }
    });
  }
  @Mutation
  private INIT_STORES_DATA(data: any): void {
    this.stores = {}
    Object.keys(data).forEach(i => {
      this.stores[i] = data[i]["project"];
      this.stores[i]["additionFields"] = data[i]["addition_fields"];
      this.stores[i]["mainImageCollection"] = data[i]["images"];
      if (data[i]["project_category_name"]) {
        this.stores[i]["project_category_name"] =
            data[i]["project_category_name"];
      }
    });
    //this.stores = data;
    this.stores = { ...this.stores };
  }

  @Mutation
  private CHANGE_ACTIVE(isActive: boolean): void {
    this.active = isActive;
  }

  @Mutation
  private CHANGE_ERROR(isError: boolean): void {
    this.requestError = isError;
  }

  @Mutation
  private CHANGE_REQUEST(isRequest: boolean): void {
    this.request = isRequest;
  }

  @Mutation
  private CHANGE_MARK(keyId: number): void {
    Object.keys(this.stores).forEach(i => {
      for (let j = 0; j < this.marks.length; j++) {
        if (
          this.stores[i].id === this.marks[j].id &&
          this.stores[i].id === keyId
        ) {
          const tmp = this.marks[j];
          if (tmp.type === "active") {
            tmp.type = "default";
          } else {
            tmp.type = "active";
          }
          Vue.set(this.marks, j, tmp);
        }
      }
    });
  }

  @Mutation
  private MAKE_ALL_MARKS_DEFAULT(): void {
    for (let i = 0; i < this.marks.length; i++) {
      const tmp = this.marks[i];
      if (tmp.type === "active") tmp.type = "default";
      this.marks[i] = tmp;
    }
  }

  @Mutation
  private MAKE_DEFAULT_STORE_DATA(): void {
    Object.keys(this.stores).forEach(i => {
      const tmp = this.stores[i];
      if (tmp.active) tmp.active = false;
      this.stores[i] = tmp;
    });
  }

  @Mutation
  private NEW_POSITION_FOR_MAP(keyId: number): void {
    Object.keys(this.stores).forEach(i => {
      if (this.stores[i].id === keyId) {
        const tmp = this.stores[i];

        tmp.active = !tmp.active;
        if (tmp.active) {
          //Set focus pin on map by click
          //changes to root property 'center'
          this.center = {
            lat: Number(this.stores[i].lat),
            lng: Number(this.stores[i].lng)
          };
          this.images = (this.stores[i].mainImageCollection.length > 0)
        }
        const tm = Object.assign({}, tmp);
        Vue.set(this.stores, i, tm);
      }
    });
  }

  @Mutation
  private FIND_MAIN_SLIDE(index: number): void {
    Object.keys(this.stores).forEach(i => {
      if (this.stores[i].active) {
        this.mainSlide = this.stores[i].mainImageCollection[
          index === -1 ? 0 : index
        ];
        return;
      }
    });
  }

  @Mutation
  private TOGGLE_POPUP(available: boolean): void {
    this.activePopUp = available;
  }

  @Action({ rawError: true })
  public togglePopUp(available: boolean): void {
    this.TOGGLE_POPUP(available);
  }

  @Action({ rawError: true })
  public tooggleActive(isActive: boolean): void {
    this.CHANGE_ACTIVE(isActive);
  }

  @Action({ rawError: true })
  public tooggleError(isError: boolean): void {
    this.CHANGE_ERROR(isError);
  }

  @Action({ rawError: true })
  public initStores(data: any): void {
    this.INIT_STORES_DATA(data);
    this.EXTEND_STORE_DATA(data);
    this.CREATE_MARKS(data);
  }

  @Action({ rawError: true })
  public wasRequest(isRequest: boolean) {
    this.CHANGE_REQUEST(isRequest);
  }

  @Action({ rawError: true })
  public changeStore(keyId: number) {
    this.MAKE_ALL_MARKS_DEFAULT();
    this.MAKE_DEFAULT_STORE_DATA();
    this.CHANGE_MARK(keyId);
    this.NEW_POSITION_FOR_MAP(keyId);
    this.FIND_MAIN_SLIDE(-1);
  }

  @Action({ rawError: true })
  public findMainSlide(index: number) {
    this.FIND_MAIN_SLIDE(index);
  }
  @Action({ rawError: true })
  async dataRequest(zip: string) {
    this.wasRequest(true);
    const request = prepareRequest(zip);
    const res = await axios(request);
    const result = JSON.parse(res["data"]);

    if (result.error) {
      this.wasRequest(false);
      this.tooggleActive(false);
      MessageModule.showMessage({
        message: result.msg
      });
      return;
    }
    this.SAVE_ZIPCODE(zip)
    if (Object.keys(result.length !== 0)) {
      this.initStores(result);
      this.tooggleActive(true);
      this.tooggleError(false);
      this.wasRequest(false);
      return;
    }
    this.wasRequest(false);
    this.tooggleActive(false);
    this.tooggleError(true);
  }
}

export const MapStoreModule = getModule(MapStore);
